import "./MainCTAButton.scss";
import { observer } from "mobx-react-lite";
import { Switch } from "antd";
import { InfoTooltip } from "../../BaseComps/InfoTooltip";
import {
  IInteractiveMod,
  IInteractiveModJSExpression,
} from "@blings/blings-player";

interface MainCTAButtonProps {
  index: number;
  change: IInteractiveModJSExpression | IInteractiveMod<any, any>;
  onChange: any;
}

function MainCTAButton(props: MainCTAButtonProps) {
  const { change, onChange } = props;
  return (
    <div className={`main-cta-button ${change.isMainCta ? "is-main-cta" : ""}`}>
      <Switch
        className="main-cta-switch"
        checked={change.isMainCta}
        onChange={() => {
          onChange(
            props.index,
            ["isMainCta"],
            [change.isMainCta ? false : true]
          );
        }}
      />
      <div className="cta-text">
        <span>Optimize for this button</span>
        <InfoTooltip
          info="Mark this button as a conversion goal for analytics and AI Optimization. Interactions with this button will be tracked in analytics and counted when comparing A/B test performance. Other interactive elements will still work, but won't affect optimization results."
          style={{ marginLeft: "0.35rem" }}
        />
      </div>
    </div>
  );
}

export default observer(MainCTAButton);
